import { render, staticRenderFns } from "./ArticleTreatmentEditDialog.vue?vue&type=template&id=62a52a28&scoped=true"
import script from "./ArticleTreatmentEditDialog.vue?vue&type=script&lang=ts"
export * from "./ArticleTreatmentEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./ArticleTreatmentEditDialog.vue?vue&type=style&index=0&id=62a52a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a52a28",
  null
  
)

export default component.exports